export const PaymentTransactionModal = ({ transaction, onClose }) => {
  if (!transaction) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex justify-center items-center">
      <div className="bg-white p-6 rounded-xl w-[500px]">

        <h2 className="text-xl font-bold mb-4">
          Payment Details
        </h2>

        <p><b>User:</b> {transaction.user?.fullName}</p>
        <p><b>Package:</b> {transaction.packageName}</p>
        <p><b>Coins:</b> {transaction.coins}</p>
        <p><b>Amount:</b> ₹{transaction.amount}</p>
        <p><b>Status:</b> {transaction.status}</p>
        <p><b>Order ID:</b> {transaction.razorpayOrderId}</p>
        <p><b>Payment ID:</b> {transaction.razorpayPaymentId}</p>

        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded"
        >
          Close
        </button>
      </div>
    </div>
  );
};